import { render, staticRenderFns } from "./SocialSignInButtons.vue?vue&type=template&id=5aefb720&"
import script from "./SocialSignInButtons.vue?vue&type=script&lang=ts&"
export * from "./SocialSignInButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SocialSignInButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
